// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__cwAKh","icon":"ThemeToggle_icon__NvQ-B"};